import { Outlet, NavLink, Link, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingCart, ClipboardList, Boxes, Users, Sparkles, MessageSquare, LogOut, Store, Tag, Layers, Sliders, Building2, Briefcase, ShoppingBag } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import AdminSessionWarning from "../components/AdminSessionWarning";
import { useBrandLogo } from "../lib/logo";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/categories", label: "Categories", icon: Layers },
  { to: "/admin/orders", label: "Orders", icon: ShoppingCart },
  { to: "/admin/ledger", label: "Ledger", icon: ClipboardList },
  { to: "/admin/purchases", label: "Purchases", icon: ShoppingBag },
  { to: "/admin/inventory", label: "Inventory", icon: Boxes },
  { to: "/admin/customers", label: "Customers", icon: Users },
  { to: "/admin/wholesalers", label: "Sellers", icon: Briefcase },
  { to: "/admin/promotions", label: "Promotions", icon: Tag },
  { to: "/admin/storefront", label: "Storefront", icon: Sliders },
  { to: "/admin/company", label: "Company", icon: Building2 },
  { to: "/admin/sms-logs", label: "SMS Logs", icon: MessageSquare },
  { to: "/admin/assistant", label: "AI Assistant", icon: Sparkles },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { logoUrl } = useBrandLogo();
  return (
    <div className="admin-surface min-h-screen flex">
      <aside className="w-64 bg-[#3B2F2F] text-[#FDFBF7] flex flex-col">
        <div className="px-6 py-6 border-b border-white/10">
          <div className="flex items-center gap-2">
            <img src={logoUrl} alt="DailyBeans" className="w-10 h-10 object-contain bg-[#FDFBF7] rounded-full p-0.5" />
            <div className="font-serif-display text-2xl">DailyBeans</div>
          </div>
          <div className="text-xs uppercase tracking-widest text-[#D4AF37] mt-2">Admin</div>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {NAV.map(n => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.label.toLowerCase().replace(' ','-')}`}
                     className={({isActive}) => `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                       isActive ? "bg-[#D4AF37] text-[#3B2F2F]" : "text-[#FDFBF7]/80 hover:bg-white/5"}`}>
              <n.icon className="w-4 h-4" />{n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10 space-y-2">
          <Link to="/" className="flex items-center gap-2 text-xs text-[#FDFBF7]/70 hover:text-[#D4AF37] px-3">
            <Store className="w-4 h-4" /> View storefront
          </Link>
          <button onClick={async ()=>{ await logout(); navigate("/admin/login"); }}
                  data-testid="admin-logout"
                  className="flex items-center gap-2 text-xs text-[#FDFBF7]/70 hover:text-[#D4AF37] px-3">
            <LogOut className="w-4 h-4" /> Sign out
          </button>
        </div>
      </aside>
      <div className="flex-1 flex flex-col min-w-0">
        <AdminSessionWarning />
        <header className="bg-white border-b border-stone-200 px-8 py-4 flex items-center justify-between">
          <div className="font-outfit text-sm text-stone-500">Welcome back,</div>
          <div className="font-outfit text-sm font-semibold text-stone-800" data-testid="admin-user">{user?.name || user?.email}</div>
        </header>
        <main className="flex-1 p-8 overflow-auto"><Outlet /></main>
      </div>
    </div>
  );
}
